'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _lodash = require('lodash');

var _LinkageSelect = require('../components/LinkageSelect');

var _LinkageSelect2 = _interopRequireDefault(_LinkageSelect);

var _util = require('../components/LinkageSelect/util');

var _formFieldUtils = require('../common/formFieldUtils');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formatter = require('../common/formatter');

var _EditForm = require('./EditForm');

var _EditForm2 = _interopRequireDefault(_EditForm);

var _DTButton = require('../components/DTButton');

var _DTButton2 = _interopRequireDefault(_DTButton);

var _ExportButton = require('../components/ExportButton');

var _ExportButton2 = _interopRequireDefault(_ExportButton);

var _BatchImportButton = require('../components/BatchImportButton');

var _BatchImportButton2 = _interopRequireDefault(_BatchImportButton);

var _service = require('../common/oss-upload-helper/service');

var _scrollTo = require('../common/scrollTo');

var _utils = require('../common/utils');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var LAYOUT_COMPONENTS = ['AutoColumnsLayout', 'GroupLayout', 'ColumnsLayout', 'Column'];

// 这里只把分栏组件的子组件抽取出来， 卡片的列计算不放在这里
var flattenChildren = function flattenChildren(children) {
  if ((0, _lodash.isEmpty)(children)) return [];
  var result = [];
  children.forEach(function (childSchema) {
    if (!(0, _lodash.isEmpty)(childSchema.children) && LAYOUT_COMPONENTS.indexOf(childSchema.componentName) > -1) {
      result = result.concat(flattenChildren(childSchema.children));
    } else {
      result.push(childSchema);
    }
  });
  return result;
};

var generateColumns = function generateColumns(props) {
  var initialSchema = props.initialSchema;

  var childSchemas = flattenChildren(initialSchema && initialSchema.children);
  var getColumn = function getColumn(item) {
    var itemProps = item && item.props || {};
    itemProps.showReadonlyValue = true;

    return {
      dataIndex: itemProps.fieldId,
      title: itemProps.label,
      width: (itemProps.label && itemProps.label.length + 5 || 10) + 'rem',
      cell: function cell(value) {
        return (0, _formatter.defaultValueFormatter)(value, item.componentName, itemProps, (0, _lodash.get)(itemProps || {}, 'dataSource.options', []));
      }
    };
  };
  // 卡片没有被拆分
  var columns = [];
  if (!(0, _lodash.isEmpty)(childSchemas)) {
    columns = childSchemas.filter(function (item) {
      var itemProps = item && item.props || {};
      // 展示的时候过滤掉隐藏列
      return itemProps.visible;
    }).map(function (item) {
      var itemProps = item && item.props || {};
      if (item.componentName === 'Card') {
        var subColumns = [];
        var cardChildren = flattenChildren(item.children);

        (0, _lodash.forEach)(cardChildren, function (child) {
          var childProps = child && child.props || {};
          if (childProps.visible === false) return true;
          if ((0, _lodash.isEmpty)(itemProps.showColumns) || itemProps.showColumns.includes(childProps.fieldId)) {
            subColumns.push(_extends({}, getColumn(child), {
              cell: function cell(value, index, record) {
                var cardData = record[itemProps.fieldId];
                if ((0, _lodash.isEmpty)(cardData)) return '';
                var resultList = cardData.map(function (row) {
                  var result = row[childProps.fieldId];
                  return (0, _formatter.defaultValueFormatter)(result, child.componentName, childProps, (0, _lodash.get)(childProps || {}, 'dataSource.options', []));
                }).filter(function (item) {
                  return !(0, _lodash.isNil)(item) && !(0, _lodash.isEmpty)(String(item));
                });
                return ['Attachment', 'RichText'].indexOf(child.componentName) > -1 ? resultList.map(function (item) {
                  return _react2.default.createElement(
                    _react.Fragment,
                    null,
                    item,
                    '\xA0'
                  );
                }) : resultList.join(',');
              }
            }));
          }
        });

        return {
          dataIndex: itemProps.fieldId,
          title: itemProps.label,
          isCard: true,
          subColumns: subColumns
        };
      } else {
        return getColumn(item);
      }
    });
  }
  return columns;
};

var getRowKey = function getRowKey(item) {
  // const newItem = cloneDeep(item);
  // delete newItem.rowKey;
  // return hashCode(JSON.stringify(newItem));
  return (0, _formFieldUtils.uuid)();
};

var AdvancedCard = (_temp = _class = function (_Field) {
  _inherits(AdvancedCard, _Field);

  AdvancedCard.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var superState = _Field.getDerivedStateFromProps.call(this, props, state);
    var columns = generateColumns(props);
    var ret = _extends({}, superState, { columns: columns });
    if (superState && superState.fieldData) {
      var total = (0, _lodash.isEmpty)(superState.fieldData.value) ? 0 : superState.fieldData.value.length;
      _extends(ret, { total: total, current: 1 }); // 刷新表格后，重新从page首页展示
    }
    return ret;
  };

  function AdvancedCard(props) {
    _classCallCheck(this, AdvancedCard);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _this.getRelaFormDataForParams = function () {
      var getRelaFormData = _this.props.getRelaFormData;

      var result = '';
      try {
        var formValue = getRelaFormData();
        var formData = formValue.content;
        result = JSON.stringify(formData);
      } catch (e) {
        console.error(e);
      }
      return result;
    };

    _this.onEditFormReady = function () {
      // 每次打开弹窗都会重新生成一个子组件的 state，每次打开弹窗时也需要触发一次对应的 event
      var _this$props = _this.props,
          initialSchema = _this$props.initialSchema,
          fieldId = _this$props.fieldId,
          $state = _this$props.$state,
          onRebindEvents = _this$props.onRebindEvents,
          onEditModalShow = _this$props.onEditModalShow;
      var _this$state = _this.state,
          modalMode = _this$state.modalMode,
          modalEditRow = _this$state.modalEditRow,
          modalLinkageAddRow = _this$state.modalLinkageAddRow;

      var childSchemas = flattenChildren(initialSchema.children);
      var subStates = {};
      if (!(0, _lodash.isEmpty)(childSchemas) && $state) {
        childSchemas.forEach(function (item) {
          var itemProps = item && item.props || {};
          var state = $state.getRoot().get(fieldId + '>' + itemProps.fieldId);
          state.set('disableCollect', true);
          // 保留组件对子组件状态的引用
          subStates[itemProps.fieldId] = state;

          // 如果打开弹窗时是共享联动选择的数据
          if (modalMode === 'add' && modalLinkageAddRow && modalLinkageAddRow[itemProps.fieldId] !== undefined) {
            state.setVal(modalLinkageAddRow[itemProps.fieldId]);
          }

          // 如果打开弹窗时是编辑数据
          if (modalMode === 'edit' && modalEditRow && modalEditRow[itemProps.fieldId] !== undefined) {
            state.setVal(modalEditRow[itemProps.fieldId]);
          }
          // 如果打开弹窗里面有卡片
          if (['Card'].includes(item.componentName)) {
            state.onChange(_this.onEditFormChange);
          }
        });
      }
      _this.subStates = subStates;
      onRebindEvents && onRebindEvents();
      onEditModalShow && onEditModalShow({
        // 增加getRunFuncFlag函数，通过 initial 参数判断是否执行事件
        // 用于解决弹窗中子组件配置了异步请求更新，打开弹窗后触发异步导致组件变成了异步请求的值，不是用户已修改的值。
        getRunFuncFlag: function getRunFuncFlag() {
          var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              initial = _ref.initial;

          // 如果事件配置中含有 initial 则根据initial来判断触发弹窗中子组件事件，如果未定义 initial，则默认触发弹窗中子组件事件
          return typeof initial !== 'undefined' ? initial : true;
        }
      });
    };

    _this.onEditFormChange = function () {
      _this.setState({
        shouldUpdatePosition: !_this.state.shouldUpdatePosition
      });
    };

    _this.onUploadSuccess = function (data) {
      if ((0, _lodash.isEmpty)(data)) {
        return;
      }
      var onChange = _this.props.onChange;

      var realValue = [];
      var realData = (0, _lodash.isString)(data) ? JSON.parse(data) : data;

      // 返回的数据为全量覆盖的形式
      (0, _lodash.forEach)(realData, function (item) {
        var rowKey = getRowKey(item);
        item.rowKey = rowKey;
        realValue.push(item);
      });

      // 先清空数据，再触发赋值
      _this.onChange(null, 'deleteAll', false);
      onChange && onChange({ value: realValue });
    };

    _this.handleAdd = function () {
      _this.setState({ modalVisible: true, modalMode: 'add', modalTitle: '新增' });
    };

    _this.handleAddLinkageShare = function (rowData) {
      var onChange = _this.props.onChange;

      onChange && onChange({ rowData: rowData });
      _this.setState({ modalVisible: true, modalMode: 'add', modalTitle: '新增', modalLinkageAddRow: rowData });
    };

    _this.handleEdit = function (rowData, index) {
      // 更新普通表格数据，用于异步请求获取请求脱敏参数
      _this.props.onChange && _this.props.onChange({ rowData: rowData });

      _this.setState({
        modalVisible: true,
        modalMode: 'edit',
        modalTitle: '修改',
        modalEditRow: rowData,
        modalEditRowIndex: index
      });
    };

    _this.handleDelete = function (rowData) {
      _next.Dialog.confirm({
        title: '确认',
        content: '确认删除该条数据?',
        onOk: function onOk() {
          _this.onChange(rowData, 'delete');
        }
      });
    };

    _this.handleDeleteAll = function () {
      _next.Dialog.confirm({
        title: '确认',
        content: '确认清空全部数据?',
        onOk: function onOk() {
          _this.onChange(null, 'deleteAll');
        }
      });
    };

    _this.handleModalOk = function () {
      var _this$state2 = _this.state,
          modalMode = _this$state2.modalMode,
          modalEditRow = _this$state2.modalEditRow,
          _this$state2$modalLin = _this$state2.modalLinkageAddRow,
          modalLinkageAddRow = _this$state2$modalLin === undefined ? {} : _this$state2$modalLin;

      if (!_this.isValid()) {
        _this.setState({ showModalMask: false });
        return false;
      }
      var rowData = _this.getFormData();
      if (modalMode === 'edit') {
        rowData = _extends({}, modalEditRow, rowData);
      }
      if (modalMode === 'add') {
        rowData = _extends({}, modalLinkageAddRow, rowData);
      }
      _this.onChange(rowData, modalMode);
      _this.setState({ modalVisible: false, modalLinkageAddRow: {} });
    };

    _this.handleModalClose = function () {
      _this.setState({ modalVisible: false, modalLinkageAddRow: {} });

      _this.props.onChange && _this.props.onChange({ rowData: {} }); // 更新普通表格数据，清空异步请求获取请求脱敏参数
    };

    _this.getFormData = function () {
      return !(0, _lodash.isEmpty)(_this.subStates) && Object.keys(_this.subStates).reduce(function (result, key) {
        var state = _this.subStates[key];
        result[key] = !(0, _lodash.isNil)(state.getVal()) ? state.getVal() : ''; // 如果为null 或undefined，需要设置为空字符串，否则在onChange出发RenderEngine无法覆盖已经存在的对象，导致展示的还是原先的对象值
        return result;
      }, {});
    };

    _this.getTableDataSource = function () {
      var _this$state3 = _this.state,
          current = _this$state3.current,
          pageSize = _this$state3.pageSize;

      var value = (0, _lodash.cloneDeep)(_this.getValue()) || [];
      var start = (current - 1) * pageSize;
      var end = current * pageSize;
      return (0, _lodash.slice)(value, start, end);
    };

    _this.isValid = function () {
      var result = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.values(_this.subStates)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var state = _step.value;

          var _ref2 = state.getData() || {},
              hasError = _ref2.hasError;

          if (hasError === true) {
            result = hasError;
            break;
          } else {
            var validateResult = state.forceValid();
            if (validateResult && validateResult.hasError === true) {
              result = true;
              break;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (result) {
        setTimeout(function () {
          (0, _scrollTo.scrollToFirstError)(document.getElementById('advanced-card__edit-form'));
        }, 100);
      }
      return !result;
    };

    _this.onChange = function (rowData, mode) {
      var showMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var onChange = _this.props.onChange;
      var _this$state4 = _this.state,
          pageSize = _this$state4.pageSize,
          total = _this$state4.total;

      var value = (0, _lodash.cloneDeep)(_this.getValue()) || [];
      var rowIndex = void 0;
      if (mode === 'add') {
        value.push(rowData);
        rowIndex = value.length - 1;
        _next.Message.notice('新增行成功');
      } else if (mode === 'edit') {
        rowIndex = (0, _lodash.findIndex)(value, function (item) {
          return item.rowKey === rowData.rowKey;
        });
        value.splice(rowIndex, 1, rowData);
        if (rowIndex < 1) {
          rowIndex = 1;
        }
        _next.Message.notice('修改行成功');
      } else if (mode === 'delete') {
        rowIndex = (0, _lodash.findIndex)(value, function (item) {
          return item.rowKey === rowData.rowKey;
        });
        value.splice(rowIndex, 1);
        // 下一个需要展示的内容是前一行
        if (rowIndex < 1) {
          rowIndex = 1;
        } else if (rowIndex === total - 1) {
          rowIndex = rowIndex - 1;
        } else {
          // 不变
        }
        _next.Message.notice('删除行成功');
      } else if (mode === 'deleteAll') {
        value = [];
        rowIndex = 1;
        if (showMessage) {
          _this.setState({ showMsg: false });
          _next.Message.notice('清空数据成功');
        }
      }
      // 计算当前修改的记录应该在第几页
      onChange && onChange({ value: value, rowData: {} }); // 更新普通表格数据，清空异步请求获取请求脱敏参数
      var nextPage = Math.ceil((rowIndex + 1) / pageSize);
      _this.setState({ current: nextPage });
    };

    var params = (0, _service.initRequestParams)(props.fieldId, props.global);
    _this.state = _extends({}, _this.state, {
      current: 1,
      pageSize: props.pageSize,
      showMask: false,
      showMsg: true,
      modalTitle: '新增',
      modalMode: 'add',
      modalVisible: false,
      shouldUpdatePosition: false,
      modalEditRow: {},
      modalLinkageAddRow: {},
      columns: generateColumns(props),
      params: params
    });
    _this.subStates = null;
    return _this;
  }

  AdvancedCard.prototype.componentDidUpdate = function componentDidUpdate() {
    var onChange = this.props.onChange;

    var prevFieldData = this.state.fieldData;
    var fieldData = (0, _lodash.cloneDeep)(prevFieldData);
    (0, _lodash.forEach)(fieldData.value, function (item) {
      if (item && !item.rowKey) {
        item.rowKey = getRowKey(item);
      }
    });
    if (JSON.stringify(fieldData) !== JSON.stringify(prevFieldData)) {
      onChange && onChange({ value: fieldData.value });

      // lock 表格时，在异步更新props.$state时，需要触发window.resize来触发 adjustSize重新计算表格bodyHeight，从而避免锁定列的maxHeight计算不准导致内容展示不全
      // 详见@alifd/next table 源码：https://github.com/alibaba-fusion/next/blob/master/src/table/lock.jsx#L60
      window.dispatchEvent((0, _utils.createNewEvent)('resize'));
    }
  };

  AdvancedCard.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      labelAlign: 'top',
      fieldClassName: 'vc-advanced-card'
    });
  };

  // 通过数据字段共享添加数据


  AdvancedCard.prototype.renderEditForm = function renderEditForm() {
    var _props = this.props,
        fieldId = _props.fieldId,
        children = _props.children;
    var _state = this.state,
        modalTitle = _state.modalTitle,
        modalVisible = _state.modalVisible,
        shouldUpdatePosition = _state.shouldUpdatePosition,
        modalEditRowIndex = _state.modalEditRowIndex;

    return _react2.default.createElement(
      _next.Dialog,
      {
        title: modalTitle,
        visible: modalVisible,
        onOk: this.handleModalOk,
        shouldUpdatePosition: shouldUpdatePosition,
        onClose: this.handleModalClose,
        onCancel: this.handleModalClose
      },
      _react2.default.createElement(_EditForm2.default, {
        parentFieldId: fieldId,
        children: children,
        initCallback: this.onEditFormReady,
        modalEditRowIndex: modalEditRowIndex
      })
    );
  };

  AdvancedCard.prototype.renderTopBar = function renderTopBar() {
    var _this2 = this;

    var _props2 = this.props,
        mode = _props2.mode,
        enableAdd = _props2.enableAdd,
        enableDelete = _props2.enableDelete,
        addButtonName = _props2.addButtonName,
        enableExport = _props2.enableExport,
        global = _props2.global,
        linkageShareData = _props2.linkageShareData;
    var _state2 = this.state,
        params = _state2.params,
        showMsg = _state2.showMsg;

    if (!enableAdd) {
      return null;
    }
    var value = this.getValue();
    var showLinkageShareBtn = linkageShareData ? (0, _util.showLinkageShare)(linkageShareData) : false;
    return _react2.default.createElement(
      'div',
      { className: 'vc-table-action-bar-top' },
      _react2.default.createElement(
        'div',
        { className: 'left-actions' },
        showLinkageShareBtn ? _react2.default.createElement(_LinkageSelect2.default, { superProps: _extends({}, this.props), handleAdd: this.handleAddLinkageShare }) : null,
        _react2.default.createElement(
          _next.Button,
          { type: 'secondary', onClick: this.handleAdd },
          _react2.default.createElement(_next.Icon, { type: 'add' }),
          ' ',
          addButtonName
        ),
        mode === 'upload' && _react2.default.createElement(_BatchImportButton2.default, {
          url: '/form/table/normal/upload',
          params: params,
          global: global,
          showMsg: showMsg,
          onSuccess: this.onUploadSuccess,
          onUpload: function onUpload() {
            _this2.setState({ showMsg: true });
          },
          getFormData: this.getRelaFormDataForParams
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'right-actions' },
        enableExport && _react2.default.createElement(_ExportButton2.default, {
          scene: 'NormalTable',
          getData: this.getValue.bind(this),
          params: params,
          disabled: (0, _lodash.isEmpty)(value)
        }),
        mode === 'upload' && _react2.default.createElement(_DTButton2.default, { params: params, getFormData: this.getRelaFormDataForParams }),
        enableDelete && _react2.default.createElement(
          _next.Button,
          { text: true, onClick: this.handleDeleteAll },
          _react2.default.createElement(_next.Icon, { type: 'delete' }),
          ' \u6E05\u7A7A\u6570\u636E'
        )
      ),
      _react2.default.createElement('div', { className: 'clear-both' })
    );
  };

  AdvancedCard.prototype.renderEmpty = function renderEmpty() {
    if (window.VisualEngine) {
      return _react2.default.createElement(
        'div',
        { className: 'vc-empty' },
        '\u8BF7\u5C06\u7EC4\u4EF6\u62D6\u5230\u6B64\u533A\u57DF(\u53EF\u62D6\u5165\u591A\u4E2A\u7EC4\u4EF6)'
      );
    } else {
      return _react2.default.createElement(
        'div',
        { className: 'vc-empty' },
        '\u7EC4\u4EF6\u5C1A\u672A\u914D\u7F6E'
      );
    }
  };

  AdvancedCard.prototype.renderTable = function renderTable() {
    var _this3 = this;

    var _state3 = this.state,
        showMask = _state3.showMask,
        pageSize = _state3.pageSize,
        total = _state3.total,
        current = _state3.current;

    var dataSource = this.getTableDataSource();
    var renderProps = {
      dataSource: dataSource,
      loading: showMask
    };
    var onPagerChange = function onPagerChange(current) {
      _this3.setState({ current: current });
    };
    var onPageSizeChange = function onPageSizeChange(pageSize) {
      _this3.setState({ current: 1, pageSize: pageSize });
    };
    return _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(
        _next.Table,
        renderProps,
        this.columns
      ),
      _react2.default.createElement(_next.Pagination, {
        style: { marginTop: '10px', textAlign: 'right' },
        pageSizeSelector: 'filter',
        pageSizePosition: 'end',
        current: current,
        pageSize: pageSize,
        onChange: onPagerChange,
        onPageSizeChange: onPageSizeChange,
        total: total
      })
    );
  };

  // 渲染表格模式


  AdvancedCard.prototype.renderTableMode = function renderTableMode() {
    var children = this.props.children;
    var behavior = this.state.behavior;

    if ((0, _lodash.isEmpty)(children)) {
      return this.renderEmpty();
    }
    return _react2.default.createElement(
      _react.Fragment,
      null,
      behavior === 'NORMAL' && this.renderTopBar(),
      this.renderTable()
    );
  };

  AdvancedCard.prototype.renderView = function renderView() {
    return _react2.default.createElement(
      'div',
      { className: 'vc-advanced-card-container', style: { width: '100%' } },
      this.renderTableMode()
    );
  };

  AdvancedCard.prototype.renderControl = function renderControl() {
    return _react2.default.createElement(
      'div',
      { className: 'vc-advanced-card-container', style: { width: '100%' } },
      this.renderEditForm(),
      this.renderTableMode()
    );
  };

  _createClass(AdvancedCard, [{
    key: 'columns',
    get: function get() {
      var _this4 = this;

      var _props3 = this.props,
          deleteButtonName = _props3.deleteButtonName,
          editButtonName = _props3.editButtonName,
          enableDelete = _props3.enableDelete,
          enableEdit = _props3.enableEdit;
      var _state4 = this.state,
          behavior = _state4.behavior,
          columns = _state4.columns;

      var isNormal = behavior === 'NORMAL';
      var realColumns = [].concat(_toConsumableArray(columns));
      var actionRender = function actionRender(value, index, record) {
        return _react2.default.createElement(
          'div',
          null,
          isNormal && enableEdit && _react2.default.createElement(
            _next.Button,
            { type: 'primary', text: true, onClick: function onClick() {
                return _this4.handleEdit(record, index);
              } },
            editButtonName
          ),
          isNormal && enableDelete && _react2.default.createElement(
            _next.Button,
            { text: true, onClick: function onClick() {
                return _this4.handleDelete(record);
              } },
            '\xA0\xA0',
            deleteButtonName
          )
        );
      };
      realColumns.push({
        dataIndex: 'action',
        title: isNormal && (enableEdit || enableDelete) ? '操作' : '',
        width: isNormal && (enableEdit || enableDelete) ? '8rem' : '1px',
        lock: 'right',
        cell: actionRender
      });
      return realColumns.map(function (item) {
        if (item.isCard && !(0, _lodash.isEmpty)(item.subColumns)) {
          return _react2.default.createElement(
            _next.Table.ColumnGroup,
            { title: item.title, align: 'center' },
            item.subColumns.map(function (item) {
              return _react2.default.createElement(_next.Table.Column, item);
            })
          );
        }
        return _react2.default.createElement(_next.Table.Column, item);
      });
    }
  }]);

  return AdvancedCard;
}(_vuFusionField2.default), _class.displayName = 'AdvancedCard', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  mode: 'simple',
  pageSize: 10,
  displayMode: 'TABLE',
  enableAdd: true,
  addButtonName: '新增',
  enableEdit: true,
  editButtonName: '修改',
  enableDelete: true,
  deleteButtonName: '删除',
  enableExport: false
}), _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), [{
  name: 'initialSchema',
  formatIn: function formatIn(initialSchema, props, states) {
    var componentSchema = states.componentSchema;

    return componentSchema || {};
  }
}, {
  name: 'fieldData',
  formatIn: function formatIn(fieldData, props) {
    var value = (0, _lodash.cloneDeep)(fieldData && fieldData.value);
    (0, _lodash.forEach)(value, function (item) {
      if (item && !item.rowKey) {
        item.rowKey = getRowKey(item);
      }
    });
    return _extends({}, fieldData, { value: value });
  }
}]), _temp);
exports.default = AdvancedCard;
module.exports = exports['default'];